var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.orderInView)?_c('OrderForm',{attrs:{"order":_vm.orderInView}}):_vm._e(),_c('div',{staticClass:"px-3"},[(_vm.orderInView)?_c('OrderDriverSearch',{attrs:{"order":_vm.orderInView}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }